// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BusinessProfileViewOpenEvent
 */
export var BusinessProfileViewOpen = function (_a) {
    var contactStatus = _a.contactStatus, context = _a.context, entryPoint = _a.entryPoint, externalId = _a.externalId, hasBio = _a.hasBio, profileCustomerToken = _a.profileCustomerToken, profileDirectoryFlowToken = _a.profileDirectoryFlowToken, profileElementsData = _a.profileElementsData, paidByPplYouKnow = _a.paidByPplYouKnow, inYourContacts = _a.inYourContacts, isFavorite = _a.isFavorite, appMessageToken = _a.appMessageToken;
    return ({
        name: "BusinessProfile View Open",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "View",
            contact_status: contactStatus !== undefined && contactStatus !== null ? contactStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            context: context !== undefined && context !== null ? context.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_bio: hasBio !== undefined && hasBio !== null ? hasBio.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_customer_token: profileCustomerToken !== undefined && profileCustomerToken !== null ? profileCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_elements_data: profileElementsData !== undefined && profileElementsData !== null ? profileElementsData.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            paid_by_ppl_you_know: paidByPplYouKnow !== undefined && paidByPplYouKnow !== null ? paidByPplYouKnow.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            in_your_contacts: inYourContacts !== undefined && inYourContacts !== null ? inYourContacts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_favorite: isFavorite !== undefined && isFavorite !== null ? isFavorite.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_message_token: appMessageToken !== undefined && appMessageToken !== null ? appMessageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractAddFavoriteEvent
 */
export var BusinessProfileInteractAddFavorite = function (_a) {
    var favoritedCustomerToken = _a.favoritedCustomerToken, appMessageToken = _a.appMessageToken, origin = _a.origin, contactEnabled = _a.contactEnabled, suggestionStrategy = _a.suggestionStrategy;
    return ({
        name: "BusinessProfile Interact AddFavorite",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            favorited_customer_token: favoritedCustomerToken !== undefined && favoritedCustomerToken !== null ? favoritedCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            app_message_token: appMessageToken !== undefined && appMessageToken !== null ? appMessageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contact_enabled: contactEnabled !== undefined && contactEnabled !== null ? contactEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            suggestion_strategy: suggestionStrategy !== undefined && suggestionStrategy !== null ? suggestionStrategy.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractRemoveFavoriteEvent
 */
export var BusinessProfileInteractRemoveFavorite = function (_a) {
    var favoritedCustomerToken = _a.favoritedCustomerToken, origin = _a.origin;
    return ({
        name: "BusinessProfile Interact RemoveFavorite",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            favorited_customer_token: favoritedCustomerToken !== undefined && favoritedCustomerToken !== null ? favoritedCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractViewHistoryEvent
 */
export var BusinessProfileInteractViewHistory = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact ViewHistory",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractViewSocialLinkEvent
 */
export var BusinessProfileInteractViewSocialLink = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact ViewSocialLink",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractViewProfileImageEvent
 */
export var BusinessProfileInteractViewProfileImage = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact ViewProfileImage",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractShareProfileEvent
 */
export var BusinessProfileInteractShareProfile = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact ShareProfile",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractReportProfileEvent
 */
export var BusinessProfileInteractReportProfile = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact ReportProfile",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileInteractBlockProfileEvent
 */
export var BusinessProfileInteractBlockProfile = function (_a) {
    var businessProfileToken = _a.businessProfileToken;
    return ({
        name: "BusinessProfile Interact BlockProfile",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Interact",
            business_profile_token: businessProfileToken !== undefined && businessProfileToken !== null ? businessProfileToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessProfileManageDowngradeToPersonalEvent
 */
export var BusinessProfileManageDowngradeToPersonal = function (_a) {
    var entryPoint = _a.entryPoint, businessDowngradeFlowToken = _a.businessDowngradeFlowToken;
    return ({
        name: "BusinessProfile Manage DowngradeToPersonal",
        parameters: {
            cdf_entity: "BusinessProfile",
            cdf_action: "Manage",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            business_downgrade_flow_token: businessDowngradeFlowToken !== undefined && businessDowngradeFlowToken !== null ? businessDowngradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
